import {
  CollectionBoxFragment,
  CreateTradeRequestInput,
  ItemDetailSelectQuery,
  Maybe,
  UserItemBoxFragment,
  UserTradableUserItemsConnectionFragment,
} from '@/clients/utoniq-core/schema'
import { Head } from '@/components/layouts'
import { useRouter } from '@/core'
import { Template } from '@/core/architecture'

import { RequestTrade } from './RequestTrade'

export * from './fragments'

export type State = {
  serialNumberSelect: {
    portfolio: Maybe<UserItemBoxFragment>
    loading: boolean
  }
  userTradableUserItems: {
    loading: boolean
    hasNextPage: boolean
    fetching: boolean
    collections: Maybe<{ edges: { node: CollectionBoxFragment }[] }>
    items: Maybe<UserTradableUserItemsConnectionFragment>
  }
  tradeItemDetailSelect: {
    loading: boolean
    portfolio: Maybe<ItemDetailSelectQuery['portfolio']>
  }
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onTradeConfirm: () => Promise<void>
  onGetUserTradableUserItems: () => Promise<void>
  onFetchMoreUserTradableUserItems: () => Promise<void>
  onGetTradeItemDetailSelect: (itemId: string) => Promise<void>
  onCreateRequestTrade: (values: CreateTradeRequestInput) => Promise<string>
}

export const SerialNumberSelectTemplate: Template<State, Action> = ({
  state,
  ...actions
}) => {
  const { routerNames } = useRouter()
  return (
    <>
      <Head title={routerNames.SerialNumberSelect} />
      <RequestTrade {...state} {...actions} />
    </>
  )
}
